import { Button } from "baseui/button"
import { useRouter } from "next/router"
import { Confetti } from "@today/ui/components/Confetti"

type Props = {
  companyName?: string
}

function RegisteredSuccessfully({ companyName }: Props) {
  const router = useRouter()
  return (
    <>
      <div className="flex flex-1 flex-col items-center justify-center text-2xl">
        <p className="text-3xl">
          <span className="font-bold">{companyName}</span>님,
        </p>
        <p className="mt-2">가입이 완료되었습니다.</p>
        <Button className="my-12" onClick={() => router.replace("/orders")}>
          로그인 페이지로 이동하기
        </Button>
      </div>
      <Confetti />
    </>
  )
}

export default RegisteredSuccessfully
